module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/settings/integrations/quickbooks/PaymentAccount.ejs -->\n<td class="td-nowrap">\n    '+
((__t=(
        model.get('affects') === 'employee' ? 'Employee' :
        model.get('affects') === 'mtd' ? 'PCB (LHDN)' :
        model.get('affects') === 'epf' ? 'EPF (KWSP)' :
        model.get('affects') === 'socso' ? 'SOCSO (PKS)' :
        model.get('affects') === 'eis' ? 'EIS' :
        model.get('affects') === 'hrdf' ? 'HRDF' :
        model.get('affects') === 'zakat' ? 'Zakat' : 'Unknown'
    ))==null?'':_.escape(__t))+
'\n</td>\n<td>\n    <select name="remoteId"\n        class="form-control">\n        <option></option>\n        ';
 qbAccounts.forEach(function (account) { 
__p+='\n            <option value="'+
((__t=( account.Id ))==null?'':_.escape(__t))+
'"\n                '+
((__t=( model.get('remoteId') === account.Id ? 'selected': '' ))==null?'':_.escape(__t))+
'>\n                '+
((__t=( account.FullyQualifiedName ))==null?'':_.escape(__t))+
'\n            </option>\n        ';
 }) 
__p+='\n    </select>\n</td>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/settings/integrations/quickbooks/PaymentAccount.ejs
// module id = 887
// module chunks = 1